import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { RLDocumentsController } from "../directives/documents";
import { DocumentEntityService } from "../services/document-entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { AclService } from "../services/acl-service";
import { SearchService } from "../services/search-service";
import { EntityConfigService } from "../services/entity-config-service";
import { ListService } from "../services/list-service";

RLDocumentFolderHierarchyItem.$inject = ["$compile"];
export function RLDocumentFolderHierarchyItem($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        restrict: "EA",
        bindToController: true,
        template: require("/assets/app/templates/document-folder-hierarchy-item.html"),
        scope: {
            locked: "=?",
            document: "=?",
            hierarchy: "=?",
            level: "@",
            canEdit: '=?',
            parentOpen: "=",
            refreshHierarchy: "=",
            refreshHierarchyEntityID: "=refreshHierarchyEntityId",
            parentEntityID: '=parentEntityId',
            moduleParentEntityID: '=moduleParentEntityId',
            itemCustomColumns: '=?',
            availableColumns: "=?",
            contactTitles: "=?",
            openFolders: "=?",
            loadedHierarchy: "=?"
        },
        controller: RLDocumentFolderHierarchyItemController,
        controllerAs: "dfhiVM",
        require: ["rlDocumentFolderHierarchyItem", "^rlDocuments"],
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLDocumentFolderHierarchyItemController, RLDocumentsController]) => {

            var ctrl: RLDocumentFolderHierarchyItemController = controllers[0];
            var rlDocumentsCtrl: RLDocumentsController = controllers[1];

            scope.$watch(() => ctrl.childEntityDocuments,
                () => {
                    if (_.any(ctrl.childEntityDocuments) && ctrl.openFolders[ctrl.document.recordID]) {
                        var parentRecID = ctrl.document.recordID;
                        var template =
                            `<tr rl-document-folder-hierarchy-item='' ng-show='dfhiVM.openFolders[${parentRecID}]' ng-repeat='childEntityDoc in dfhiVM.childEntityDocuments' document='childEntityDoc.root' hierarchy='childEntityDoc' locked='dfhiVM.locked' can-edit='dfhiVM.canEdit' refresh-panel='dfhiVM.refreshPanel' level='{{ dfhiVM.levelInt + 1 }}' parent-entity-id='dfhiVM.document.entityID' module-parent-entity-id='dfhiVM.moduleParentEntityID' item-custom-columns='dfhiVM.itemCustomColumns' available-columns='dfhiVM.availableColumns' contact-titles='dfhiVM.contactTitles' open-folders='dfhiVM.openFolders' loaded-hierarchy='dfhiVM.loadedHierarchy'></tr>`
                        var el = angular.element(template);
                        var compiled = $compile(el);
                        element.after(el);
                        compiled(scope);
                    }
                });

            scope.$watch(() => ctrl.uploadModalOpen, (newValue, oldValue) => {
                if (newValue != oldValue && newValue) {
                    rlDocumentsCtrl.OpenUploadModal(ctrl.documentTemplate, ctrl.document.entityID);
                    ctrl.uploadModalOpen = false;
                }
            });

            scope.$watch(() => ctrl.deleteDocumentEntityID, (newValue, oldValue) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    if (ctrl.deletingFolder) {
                        rlDocumentsCtrl.DeleteDocumentFolder(ctrl.deleteDocumentEntityID);
                    }
                    else {
                        rlDocumentsCtrl.DeleteDocumentEntity(ctrl.deleteDocumentEntityID);
                    }
                    ctrl.deletingFolder = false;
                    ctrl.deleteDocumentEntityID = "";
                }
            });

            scope.$watch(() => ctrl.editDocumentEntityID, (newValue, oldValue) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    rlDocumentsCtrl.parentEntityID = ctrl.parentEntityID;
                    rlDocumentsCtrl.EditDocumentEntity(ctrl.editDocumentEntityID);
                    ctrl.editDocumentEntityID = "";
                }
            });

            scope.$watch(() => ctrl.viewDocumentEntityID, (newValue, oldValue) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    rlDocumentsCtrl.ViewDocumentEntity(ctrl.viewDocumentEntityID);
                    ctrl.viewDocumentEntityID = "";
                }
            });

            scope.$watch(() => ctrl.versionDocumentEntityID, (newValue, oldValue) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    rlDocumentsCtrl.GetDocumentVersions(ctrl.versionDocumentEntityID);
                    ctrl.versionDocumentEntityID = "";
                }
            });

            scope.$watch(() => ctrl.showAssocUserDocumentEntityID, (newValue, oldValue) => {
                if (newValue != undefined && !_.isEmpty(newValue)) {
                    rlDocumentsCtrl.ShowAssocUsers(ctrl.showAssocUserDocumentEntityID);
                    ctrl.showAssocUserDocumentEntityID = "";
                }
            });

            scope.$watch(() => ctrl.selectedDocumentRecID, (newValue, oldValue) => {
                if (newValue != undefined && newValue > 0) {
                    if (rlDocumentsCtrl.selectedDocumentEntityRecIDs.length == 0) {
                        rlDocumentsCtrl.selectedDocumentEntityRecIDs.push(ctrl.selectedDocumentRecID);
                    }
                    else {
                        if (_.any(rlDocumentsCtrl.selectedDocumentEntityRecIDs, e => e == ctrl.selectedDocumentRecID)) {
                            _.remove(rlDocumentsCtrl.selectedDocumentEntityRecIDs, e => e == ctrl.selectedDocumentRecID);
                        }
                        else {
                            rlDocumentsCtrl.selectedDocumentEntityRecIDs.push(ctrl.selectedDocumentRecID);
                        }
                    }
                    ctrl.selectedDocumentRecID = 0;
                }
            });

            scope.$watch(() => ctrl.showFolderUploadModal, (newValue, oldValue) => {
                if (newValue != oldValue && newValue) {
                    rlDocumentsCtrl.ShowFolderUpload(ctrl.selectedFolderTemplateID, ctrl.document.entityID);
                    ctrl.showFolderUploadModal = false;
                }
            });
        }
    };
    return directive;
}

class RLDocumentFolderHierarchyItemController {
    static $inject = ["$scope", "$sce", "$q", "$window", "documentEntityService", "notifyService", "eventService", "entityService", "aclService", "searchService", "entityConfigService", 'listService'];
    folderEntityID: string;
    locked: boolean;
    hierarchy: Models.IEntityHierarchy;
    loadedHierarchy: Models.IEntityHierarchy[];
    document: Models.IEntitySearchDoc;
    totalDescendants: number;
    level: string;
    levelInt: number;
    childEntityDocuments: Models.IEntityHierarchy[];
    childCount: number;
    open: boolean;
    arrowClass: string;
    emptyClass: string;
    firstTimeThroughComplete: boolean;
    parentOpen: boolean;
    documentTemplates: Models.ICharacteristicTemplate[];
    editDocumentCharDataCollection: Models.ICharDataCollection;
    createFolderMode: boolean;
    newFolderName: string;
    uploadModalOpen: boolean;
    editDocumentID: string;
    divID: number;
    docTemplateID: string;
    documentTemplate: Models.ICharacteristicTemplate;
    loading: boolean;
    deleteDocumentEntityID: string;
    documentFolderTemplateGroupID: number = Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID;
    editDocumentEntityID: string;
    viewDocumentEntityID: string;
    downloadDocumentEntityID: string;
    refreshHierarchy: boolean;
    refreshHierarchyEntityID: string;
    documentUrls: _.Dictionary<string>;
    versionDocumentEntityID: string;
    fileCharSolrLbl: string;
    showAssocUserDocumentEntityID: string;
    selectedDocumentRecID: number;
    deletingFolder: boolean;
    parentEntityID: string;
    moduleParentEntityID: string;
    itemCustomColumns: Models.ICustomUserColumns;
    documentRows: Models.IListTableRow[];
    availableColumns: Models.IListTableColumn[];
    documentFolderTemplates: Models.ICharacteristicTemplate[];
    documentFileTemplates: Models.ICharacteristicTemplate[];
    selectedFolderTemplateID: number;
    showFolderUploadModal: boolean;
    uploadedBy: string;
    contactTitles: _.Dictionary<string>;
    openFolders: _.Dictionary<boolean>;

    constructor($scope: ng.IScope,
        private $sce: ng.ISCEService,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private documentEntityService: DocumentEntityService,
        private notifyService: NotifyService,
        private eventService: EventService,
        private entityService: EntityService,
        private aclService: AclService,
        private searchService: SearchService,
        private entityConfigService: EntityConfigService,
        private listService: ListService) {

        this.arrowClass = "fa-caret-right";
        this.emptyClass = "mrm";
        this.documentTemplates = [];
        this.documentUrls = {};
        this.deletingFolder = false;
        this.showFolderUploadModal = false;

        $scope.$watchCollection(() => [this.document, this.itemCustomColumns, this.availableColumns], (newValue, oldValue) => {
            if (this.itemCustomColumns && this.document && this.availableColumns) {
                var documents: Models.IEntitySearchDoc[] = [];
                documents.push(this.document);
                this.documentRows = this.listService.GetRows(documents, this.itemCustomColumns.columns, this.availableColumns, {}, {});
            }
        });
    }

    $onInit() {
        this.levelInt = _.parseInt(this.level);
        this.loading = true;
        var promises = [];

        if (this.document.charTypeID == Consts.CharTypeIDs.document && this.document.templateGroupID != Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID) {
            promises.push(this.documentEntityService.getDocumentDownloadUrl(this.document.entityID)
                .then((result) => {
                    if (result.success) {
                        this.documentUrls[this.document.recordID] = result.data;
                    }
                }));
        }

        if (this.document.charTypeID == Consts.CharTypeIDs.document && this.document.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID) {

            promises.push(this.searchService.getChildHierarchyCount(this.document.entityID)
                .then((result) => {
                    if (result.success) {
                        this.childCount = result.data;
                    }
                }));

            promises.push(this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.document, this.document.templateID, Consts.CharTypeIDs.document) // MF
                .then((templates) => {
                    this.documentTemplates = templates.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
                    this.documentFolderTemplates = this.documentTemplates.filter(t => t.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID);
                    this.documentFileTemplates = this.documentTemplates.filter(t => t.templateGroupID != Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID);
                    if (this.documentFolderTemplates.length > 0) {
                        this.selectedFolderTemplateID = this.documentFolderTemplates[0].templateID;
                    }
                }));
        }

        this.$q.all(promises)
            .then((result) => {
                this.loading = false;
            });
    }

    OpenUploadModal(template: Models.ICharacteristicTemplate) {
        this.documentTemplate = template;
        this.uploadModalOpen = true;
    }

    Toggle() {
        this.loading = true;
        if (this.openFolders[this.document.recordID]) {
            var documentHierarchy = _.find(this.loadedHierarchy, h => h.root.recordID == this.document.recordID);
            this.closeFolders(documentHierarchy.children);
            this.openFolders[this.document.recordID] = false;
            this.loading = false;
        }
        else {
            var docCreatedByList: number[] = [];
            var difference: number[] = [];
            this.openFolders[this.document.recordID] = true;
            if (this.childCount > 0 && this.childEntityDocuments == undefined) {
                this.searchService.getEntityHierarchy(this.document.entityID, Consts.CharTypeIDs.document, 1)
                    .then((results) => {
                        if (results.success) {
                            this.loadedHierarchy.push(results.data);
                            this.childEntityDocuments = results.data.children;
                            docCreatedByList = _.unique(this.childEntityDocuments.map(c => c.root.lastUpdatedBy));
                            var currentContactTitleKeys: number[] = [];
                            currentContactTitleKeys = _.keys(this.contactTitles).map(Number);
                            difference = _.difference(docCreatedByList, currentContactTitleKeys);
                            this.document = results.data.root;
                        }
                    })
                    .finally(() => {
                        if (difference.length > 0) {
                            this.getContactTitles(difference)
                                .then(() => {
                                    this.loading = false;
                                });
                        }
                        else {
                            this.loading = false;
                        }
                    });
            }
            else {
                this.loading = false;
            }
        }
    }

    closeFolders(hierarchyChildren: Models.IEntityHierarchy[]) {
        hierarchyChildren.forEach((child) => {
            if (this.openFolders[child.root.recordID]) {
                this.openFolders[child.root.recordID] = false;
                var openFolderItem = _.find(this.loadedHierarchy, l => l.root.recordID == child.root.recordID);
                this.closeFolders(openFolderItem.children);
            }
        });
    }

    getContactTitles(contctRecIDs: number[]) {
        this.notifyService.startProgress();
        var request: Models.ISearchResultByRecordIDsRequest = {
            charTypeID: Consts.CharTypeIDs.user,
            recordIDs: contctRecIDs.join(",")
        }
        return this.entityService.getRecordDocumentsForRecordIDs(request)
            .then((result) => {
                _.forEach(result.documents, (recordDocument) => {
                    this.contactTitles[recordDocument.recordID] = recordDocument.title;
                });
                this.notifyService.endProgress();
            });
    }

    EditDocument(documentEntityID: string) {
        this.editDocumentEntityID = documentEntityID;
    }

    DeleteDocument(document: Models.IEntitySearchDoc) {
        if (document.templateGroupID == Consts.TemplateGroupIDs.DocumentFolderTemplateGroupID) {
            this.deletingFolder = true;
        }
        else {
            this.deletingFolder = false;
        }
        this.deleteDocumentEntityID = document.entityID;
    }

    ViewDocument(documentEntityID: string) {
        this.viewDocumentEntityID = documentEntityID;
    }

    GetDocumentVersions(documentEntityID: string) {
        this.versionDocumentEntityID = documentEntityID;
    }

    ShowAssocUsers(documentEntityID: string) {
        this.showAssocUserDocumentEntityID = documentEntityID;
    }

    SelectDocumentEntity(documentRecID: number) {
        this.selectedDocumentRecID = documentRecID;
    }

    CanDelete(document: Models.IEntitySearchDoc) {
        if (document != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.document, document.templateGroupID, document.templateID);
            return Utils.AclUtil.hasDeleteAccess(this.aclService.acls, acl);
        }
    }

    ShowFolderUpload() {
        this.showFolderUploadModal = true;
    }
}